<template lang="pug">
  v-container.pa-5(fill-height='', fluid='', grid-list-xl='')
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-layout(wrap='')
      <!-- content -->
      base-material-card(icon='mdi-earth' title='Usuarios', style='width:100%')
        v-row
          v-col(cols="12")
            h1 Lista de Usuarios
            v-btn(color="primary" :loading="loadingVshops" @click="disabVshops") deshabilitar tiendas virtuales
            v-row
              v-col(cols="12" md="8")
                v-row
                  v-col(cols="12" md="6" offset-md="6")
                    v-text-field(label="Buscar" v-model="searchUserItem" @keyup="searchUser")
                  v-col(cols="12")
                    v-progress-linear(indeterminate='' color='green' v-if="progressUsers")
                    v-skeleton-loader.mx-auto(tile type='article' transition='scale-transition' v-if='userListFilter.length ==  0')
                    v-data-table.data-table-scroll(v-if='userListFilter.length >  0' :headers='headers', :items='userListFilter', hide-default-footer='', disable-pagination, style="height: 615px; overflow-y: scroll;")
                      template
                        v-card-text
                      template(v-slot:item.actions="{ item }")
                        v-btn(v-on='on' icon='' color='blue' @click="selectUserMethod(item)")
                          v-icon mdi-account-check-outline
              v-col(cols="12" md="4")
                h3 Plan
                v-row
                  v-col(cols="12" md="6")
                    v-text-field(label="Plan" v-model="suscriptionData.planId" type="text" disabled="true")
                  v-col(cols="12" md="6")
                    v-text-field(label="Estado" v-model="suscriptionData.status" type="text" disabled="true")
                  v-col(cols="12" md="6")
                    v-text-field(label="Periodo" v-model="suscriptionData.periodStart" type="text" disabled="true")
                  v-col(cols="12" md="6")
                    v-text-field(label="Fecha" v-model="suscriptionData.periodEnd" type="text" disabled="true")
                h3 Restricciones
                v-row
                  v-vol(cols="12")
                    v-row
                      v-col(cols="12" md="6")
                        v-menu(ref='menuFrom' v-model='menuFrom' :close-on-content-click='false' :return-value.sync='date' transition='scale-transition' offset-y='' min-width='290px')
                          template(v-slot:activator='{ on }')
                            v-text-field(v-model='dateFrom' label='Fecha Desde' prepend-icon='mdi-calendar' readonly='' v-on='on')
                          v-date-picker(v-model='dateFrom' no-title='' scrollable='' :min="nowDate" :max="dateUntil")
                            v-spacer
                            v-btn(text='' color='primary' @click='menuFrom = false') Cancelar
                            v-btn(text='' color='primary' @click='$refs.menuFrom.save(dateFrom)') Listo
                      v-col(cols="12" md="6")
                        v-menu(ref='menuUntil' v-model='menuUntil' :close-on-content-click='false' :return-value.sync='date' transition='scale-transition' offset-y='' min-width='290px')
                          template(v-slot:activator='{ on }')
                            v-text-field(v-model='dateUntil' label='Fecha Hasta' prepend-icon='mdi-calendar' readonly='' v-on='on')
                          v-date-picker(v-model='dateUntil' no-title='' scrollable='' :min="dateFrom")
                            v-spacer
                            v-btn(text='' color='primary' @click='menuUntil = false') Cancelar
                            v-btn(text='' color='primary' @click='$refs.menuUntil.save(dateUntil)') Listo
                  v-col(cols="12" md="8")
                    v-text-field(label="Usuario" v-model="userSelected.email" type="text" disabled="true" v-if="userSelected!=null")
                  v-col(cols="12" md="4")
                    v-switch(v-if="userSelected!=null" v-model="userRestrictions.active")
                      template(v-slot:label="")
                        b
                          | ACTIVAR
                v-text-field(label="Colaboradores" v-model="userRestrictions.collaborators" type="number" min="0")
                v-tooltip(bottom='')
                  template(v-slot:activator='{ attrs, on }')
                    v-text-field(v-on="on" label="Dias de TIENDA VIRTUAL gratis" v-model="userRestrictions.freeVirtualShopDays" type="number" min="0")
                  span Días de prueba para poder activar una tienda virtual a un usuario con 0 tiendas virtuales. Se limita a una sola tienda.
                v-text-field(label="Puntos de Venta" v-model="userRestrictions.salePoints" type="number" min="0")
                v-text-field(label="Tiendas Virtuales" v-model="userRestrictions.virtualShops" type="number" min="0")
                v-text-field(label="Días de Prueba" v-model="userRestrictions.trialDays" type="number" min="0")
                div
                  v-row
                    v-col(cols="12")
                      v-btn-toggle.main-filter__button-row.main-filter__button-row--right.mx-auto(shaped, borderless,)
                        v-btn(@click="setCurrentPlan('reactivate')" color="primary" small).mx-1
                          | Reactivate
                          v-icon
                        v-btn(@click="setCurrentPlan('business')" color="primary" small).mx-1
                          | Business
                          v-icon
                        v-btn(@click="setCurrentPlan('enterprise')" color="primary" small).mx-1
                          | Enterprise
                          v-icon
                        v-btn(@click="setCurrentPlan('corporate')" color="primary" small).mx-1
                          | Corporate
                          v-icon
                  v-row
                    v-col(cols="12" md="5")
                      v-btn(color='info' style="width: 100%;" @click="saveRestrictions" :loading="loadingSave")
                        v-icon(small) mdi-content-save
                        | GUARDAR
                    v-col(cols="12" md="7")
                      v-btn(color='gray' style="width: 100%;"  @click="renewTrialDays" :loading="loadingSaveTrialDays")
                        v-icon(small) mdi-refresh
                        | RENOVAR DÍAS DE PRUEBA
                  v-btn(color='orange' style="width: 100%;" @click="cleandData")
                    v-icon(small) mdi-close
                    | LIMPIAR
</template>
<script>
  import moment from 'moment'
  import axios from 'axios'
  import * as vars from '@/vars.json'

  const httpAxios = axios.create({
    params: {},
  })
  export default {
    data () {
      return {
        loadingVshops: false,
        progressUsers: false,
        nowDate: new Date().toISOString().substr(0, 10),
        dateFrom: new Date().toISOString().substr(0, 10),
        currentIdSubscription: '',
        shopsList: [],
        collaboratorsList: [],
        hasPaymentSubscription: false,
        planPersonalizado: {
          data: {
            cost: 0,
            heading: 'Plan Personalizado',
            icon: 'mdi-home',
            position: 0,
            id_plan: 'Plan_Personalizado',
            restrictions: {
              collaborators: 0,
              freeVirtualShopDays: 0,
              salePoints: 0,
              virtualShops: 0,
            },
            text: 'plan Personalizado',
            title: 'PERSONALIZADO',
            type: 'month',
          },
        },
        menuFrom: false,
        dateUntil: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10),
        menuUntil: false,
        loadingSave: false,
        loadingSaveTrialDays: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        searchUserItem: '',
        loadingCancel: false,
        userListFilter: [],
        userSelected: null,
        headers: [
          {
            sortable: true,
            text: 'UID',
            value: 'uid',
            align: 'left',
          },
          {
            sortable: true,
            text: 'EMAIL',
            value: 'email',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('payment.general.actions'),
            value: 'actions',
            align: 'left',

          },
        ],
        suscriptionData: {
          planId: '',
          status: '',
          periodStart: '',
          periodEnd: '',
        },
        userRestrictions: {
          collaborators: 0,
          freeVirtualShopDays: 0,
          salePoints: 0,
          virtualShops: 0,
          active: false,
          trialDays: 0,
          dateFrom: null,
          dateUntil: null,
        },
      }
    },
    computed: {
      usersLst () {
        return this.$store.state.users.usersLst
      },
    },
    watch: {
      usersLst () {
        this.userListFilter = this.usersLst
      },
    },
    created () {
      this.progressUsers = true
      this.$store.dispatch('users/getUserLst').then(res => {
        this.progressUsers = false
      })
    },
    methods: {
      disabVshops () {
        const vm = this
        vm.loadingVshops = true
        httpAxios.post(vars.url + '/disabVshops').then((res) => {
          vm.loadingVshops = false
          // console.log(res)
        })
      },
      cleandData () {
        this.userRestrictions = {
          collaborators: 0,
          freeVirtualShopDays: 0,
          salePoints: 0,
          virtualShops: 0,
          active: false,
          trialDays: 0,
          dateFrom: null,
          dateUntil: null,
        }
        this.suscriptionData = {
          planId: '',
          status: '',
          periodStart: '',
          periodEnd: '',
        }
        this.userListFilter = this.usersLst
        this.userSelected = null
        this.searchUserItem = ''
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      searchUser () {
        this.userListFilter = this.usersLst.filter((item) => {
          return (item.uid.toUpperCase().includes(this.searchUserItem.toUpperCase()) || item.email.toUpperCase().includes(this.searchUserItem.toUpperCase()))
        })
      },
      selectUserMethod (user) {
        this.userSelected = user
        const data = {
          uid: this.userSelected.uid,
          restrictions: this.userRestrictions,
        }
        this.$store.dispatch('users/getDataSubscription', this.userSelected.uid).then(res => {
          // console.log(res)
          if (res) {
            this.currentIdSubscription = res.id
            this.hasPaymentSubscription = true
            this.suscriptionData = {
              planId: res.data.idClient,
              status: res.status.val,
              periodStart: res.data.createdAt.substring(0, 10),
              periodEnd: res.data.createdAt,
            }
          } else {
            this.hasPaymentSubscription = false
            this.suscriptionData = {
              planId: 'Sin Plan',
              status: 'Inactivo',
              periodStart: '',
              periodEnd: '',
            }
          }
        }, reject => {
          this.hasPaymentSubscription = false
          this.suscriptionData = {
            planId: 'Sin Plan',
            status: 'Inactivo',
            periodStart: '',
            periodEnd: '',
          }
        })
        this.$store.dispatch('users/getUserRestrictions', data).then((res) => {
          if (res) {
            if (res.data !== '') {
              if (res.data.dateFrom === null) {
                res.data.dateFrom = new Date(this.dateFrom).getTime()
                res.data.dateUntil = new Date(this.dateUntil).getTime()
              }
              this.userRestrictions = res.data
              this.dateFrom = moment(this.userRestrictions.dateFrom).format('YYYY-MM-DD')
              this.dateUntil = moment(this.userRestrictions.dateUntil).format('YYYY-MM-DD')
            } else {
              this.userRestrictions = {
                collaborators: 0,
                freeVirtualShopDays: 0,
                salePoints: 0,
                virtualShops: 0,
                active: false,
                trialDays: 0,
              }
            }
          }
        })
        this.$store.dispatch('users/loadShopsByUser', this.userSelected.uid).then((res) => {
          this.shopsList = res
        })
        this.$store.dispatch('users/getCollaboratorsByUser').then(res => {
          this.collaboratorsList = res
        })
      },
      renewTrialDays () {
        this.loadingSaveTrialDays = true
        if (this.userSelected) {
          const data = {
            uid: this.userSelected.uid,
          }
          this.$store.dispatch('users/renewTrialDays', data).then((res) => {
            this.loadingSaveTrialDays = false
            if (res) {
              this.setDataNotification(true, 'success', 'Renovación realizada de manera correcta.')
            } else {
              this.setDataNotification(true, 'error', 'Error al momento de realizar la renovación.')
            }
          })
        } else {
          this.loadingSaveTrialDays = false
          this.setDataNotification(true, 'error', 'Debe seleccionar un usuario para continuar.')
        }
      },
      saveRestrictions () {
        const vm = this
        vm.loadingSave = true
        if (vm.userSelected) {
          vm.userRestrictions.dateFrom = new Date(vm.dateFrom).getTime()
          vm.userRestrictions.dateUntil = new Date(vm.dateUntil).getTime()
          const data = {
            uid: vm.userSelected.uid,
            restrictions: vm.userRestrictions,
          }
          if (vm.hasPaymentSubscription && vm.suscriptionData.planId !== 'Plan_Reactivate' && vm.suscriptionData.status === 'active') {
            vm.cancelSubscription()
          }
          vm.$store.dispatch('users/saveRestrictions', data).then((res) => {
            vm.loadingSave = false
            if (res) {
              vm.setDataNotification(true, 'success', 'Restricciones guardadas de manera correcta.')
            } else {
              vm.setDataNotification(true, 'error', 'Error al momento de guardar las restricciones.')
            }
          })
        } else {
          vm.loadingSave = false
          vm.setDataNotification(true, 'error', 'Debe seleccionar un usuario para continuar.')
        }
      },
      cancelSubscription () {
        const vm = this
        const dataSubscription = {
          id_subscription: this.currentIdSubscription,
          txtMotive: ' CAMBIO A PLAN PERSONALIZADO',
          shops: vm.shopsList,
          collaborators: vm.collaboratorsList,
        }
        vm.$store.dispatch('payment/cancelSubscription', dataSubscription, vm.shopsList).then(res => {
        })
      },

      setCurrentPlan (plan) {
        const vm = this
        switch (plan) {
          case 'reactivate':
            vm.userRestrictions = {
              collaborators: 0,
              freeVirtualShopDays: 0,
              salePoints: 1,
              virtualShops: 1,
              active: true,
              trialDays: 0,
              dateFrom: new Date(vm.dateFrom).getTime(),
              dateUntil: new Date(vm.dateUntil).getTime(),
            }
            break
          case 'business':
            vm.userRestrictions = {
              collaborators: 2,
              freeVirtualShopDays: 0,
              salePoints: 2,
              virtualShops: 1,
              active: true,
              trialDays: 0,
              dateFrom: new Date(vm.dateFrom).getTime(),
              dateUntil: new Date(vm.dateUntil).getTime(),
            }
            break
          case 'enterprise':
            vm.userRestrictions = {
              collaborators: 4,
              freeVirtualShopDays: 0,
              salePoints: 4,
              virtualShops: 2,
              active: true,
              trialDays: 0,
              dateFrom: new Date(vm.dateFrom).getTime(),
              dateUntil: new Date(vm.dateUntil).getTime(),
            }
            break
          case 'corporate':
            vm.userRestrictions = {
              collaborators: 10,
              freeVirtualShopDays: 0,
              salePoints: 10,
              virtualShops: 4,
              active: true,
              trialDays: 0,
              dateFrom: new Date(vm.dateFrom).getTime(),
              dateUntil: new Date(vm.dateUntil).getTime(),
            }
            break
        }
      },
    },
  }
</script>
